import Flickity from "flickity";

export function Carousels() {
  let _carousels;

  // Methods
  const init = () => {
    // if (window.innerWidth > 990) {
      _selectCarousels();
      _initCarousels();
    // }

    // window.addEventListener('resize', (e) => {
    //   if (window.innerWidth > 990) {
    //     _selectCarousels();
    //     _initCarousels();
    //   }
    // });
  };

  const _selectCarousels = () => {
    _carousels = document.querySelectorAll('.carousel');
  };

  const _initCarousels = () => {
    if (_carousels.length) {
      _carousels.forEach(el => {
        let flkty = new Flickity(el, {
          cellSelector: '.carousel__cell',
          wrapAround: true,
          imagesLoaded: true,
          autoPlay: 5000,
        });
      });
    }
  };

  return { init };
}
